import React from 'react';

const Prophecy=()=>{
    return(
        <>
        <p>Prophecy</p>
        </>
    );
}

export default Prophecy;